"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPhoneNumber = exports.isEmail = exports.isRequired = exports.default = void 0;

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return function (value) {
    return validators.reduce(function (error, validator) {
      return error || validator(value);
    }, undefined);
  };
};

exports.default = _default;

var isRequired = function isRequired(value) {
  return value ? undefined : 'Required';
};

exports.isRequired = isRequired;

var isEmail = function isEmail(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? undefined : 'Must be valid email';
};

exports.isEmail = isEmail;

var isPhoneNumber = function isPhoneNumber(value) {
  return /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(value) ? undefined : 'Must be valid phone number';
};

exports.isPhoneNumber = isPhoneNumber;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/comments/validation.js
// module id = 380
// module chunks = 0 15 16 17 18